<template>
  <tr>
    <td>{{ item.keyword }}</td>
    <td>{{ item.url | removeDomain(project.siteUrl) }}</td>
    <td class="c-text--center">
      <div class="c-alertPos">
        <Alert v-if="error.delete">{{ error.delete }}</Alert>
        <Button
          radius
          variant="delete"
          :disabled="isLoading || isProcessing"
          @click="remove"
        >
          <Tooltip v-if="!isProcessing && !error.delete" variant="btn">
            キーワードを削除
          </Tooltip>
        </Button>
      </div>
    </td>
  </tr>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import apiProjects from '@/api/projects';

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Tooltip
  },
  data() {
    return {
      error: {
        delete: ''
      },
      timeoutId: null,
      isProcessing: false
    };
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    remove() {
      if (this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      apiProjects.observationKeywords
        .delete(this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          this.isProcessing = false;
          this.$emit('delete', this.index);
        })
        .catch(error => {
          if (error.response) {
            this.error.delete = error.response.data.errors[0].userMessage;

            // 削除失敗時のエラーメッセージを消すのに丁度いいトリガーがないので、3秒後に消すようにする
            this.timeoutId = setTimeout(() => {
              this.error.delete = '';
            }, 3000);
          }
          this.isProcessing = false;
        });
    }
  }
};
</script>
